module.exports = __webpack_public_path__ + "media/game_grid_01.cf1ad15c.mp4";